<div class="cds-sidebar-menu">
  <div class="cds-sidebar-menu-item">
    <button
      type="button"
      data-bs-toggle="collapse"
      data-bs-target="#collapseSample"
      aria-expanded="false"
      aria-controls="collapseSample"
      class="cds-sidebar-menu-item-toggle collapsed"
      (click)="processMContainerIsCollapsed = !processMContainerIsCollapsed"
    >
      @if (!processMContainerIsCollapsed) {
        <i class="fa fa-caret-right"></i>
      }
      @if (processMContainerIsCollapsed) {
        <i class="fa fa-caret-up"></i>
      }
    </button>
    <div class="cds-sidebar-menu-item-icon">
      <img
        class="mr-2"
        src="assets/img/icon-coloured-world.svg"
        alt="Process Management"
      />
    </div>
    <div class="cds-sidebar-menu-item-text" translate>Process Management</div>
  </div>
  <div id="collapseSample" #myDiv class="collapse">
    <a
      [routerLink]="['/process-management/process-list']"
      class="cds-sidebar-menu-item"
      [ngClass]="{
        active: checkIfThisRouteIsActive('/process-management/process-list'),
      }"
    >
      <div class="cds-sidebar-menu-item-spacer"></div>
      <div class="cds-sidebar-menu-item-icon">
        <img
          class="mr-2"
          src="assets/img/icon-coloured-users.svg"
          alt="My Processes"
        />
      </div>
      <div class="cds-sidebar-menu-item-text" translate>My Processes</div>
    </a>
    @for (process of getCurrentProcessArray(); track process; let i = $index) {
      <div>
        <a
          class="cds-sidebar-menu-item submenu"
          data-bs-toggle="collapse"
          href="#collapseExample{{ i }}"
          role="button"
          aria-expanded="false"
          [attr.aria-controls]="'collapseExample' + i"
          (click)="
            navigateToProcess(process, 'process-management/process', process.id)
          "
          [ngClass]="{
            active: checkProcessRouteActive(
              'process-management/process',
              process.id
            ),
          }"
          translate
        >
          <div class="cds-sidebar-menu-item-spacer"></div>
          <div class="cds-sidebar-menu-item-icon">
            <img
              class="mr-2"
              [src]="getImageAgainstProcessStatus(process.s1ProcessInfo)"
              [alt]="process.s1ProcessInfo.nameDisplay"
            />
          </div>
          <div class="cds-sidebar-menu-item-text">
            {{ process.s1ProcessInfo.nameDisplay }}
          </div>
        </a>
        <div class="collapse" id="collapseExample{{ i }}">
          @for (item of processRoutes; track item) {
            <a
              class="cds-sidebar-menu-item submenu"
              (click)="navigateToProcess(process, item.route, process.id)"
              [ngClass]="{
                'active submenu-element': checkProcessRouteActive(
                  item.route,
                  process.id
                ),
              }"
            >
              <div class="cds-sidebar-menu-item-spacer"></div>
              <div class="cds-sidebar-menu-item-spacer"></div>
              <div class="cds-sidebar-menu-item-icon">
                <img class="mr-2" [src]="item.imgSrc" [alt]="item.label" />
              </div>
              <div class="cds-sidebar-menu-item-text" translate>
                {{ item.label }}
              </div>
            </a>
          }
        </div>
      </div>
    }
  </div>
  <div class="cds-sidebar-menu-item">
    <button
      type="button"
      data-bs-toggle="collapse"
      data-bs-target="#collapseSample2"
      aria-expanded="false"
      aria-controls="collapseSample2"
      class="cds-sidebar-menu-item-toggle collapsed"
      (click)="
        installationMContainerIsCollapsed = !installationMContainerIsCollapsed
      "
    >
      @if (!installationMContainerIsCollapsed) {
        <i class="fa fa-caret-right"></i>
      }
      @if (installationMContainerIsCollapsed) {
        <i class="fa fa-caret-up"></i>
      }
    </button>
    <div class="cds-sidebar-menu-item-icon">
      <img
        class="mr-2"
        src="assets/img/icon-coloured-skyscrapers.svg"
        alt="Installation Management"
      />
    </div>
    <div class="cds-sidebar-menu-item-text" translate>
      Installation Management
    </div>
  </div>
  <div id="collapseSample2" class="collapse">
    @if (
      authorizationService.hasPermission("SYSTEM_ADMIN,MANAGER,SECURITY_ADMIN")
    ) {
      <a
        [routerLink]="['/installation-management/user-creation']"
        class="cds-sidebar-menu-item"
        [ngClass]="{
          active: checkIfThisRouteIsActive(
            '/installation-management/user-creation'
          ),
        }"
      >
        <div class="cds-sidebar-menu-item-spacer"></div>
        <div class="cds-sidebar-menu-item-icon">
          <img
            class="mr-2"
            src="assets/img/icon-coloured-users.svg"
            alt="User Management"
          />
        </div>
        <div class="cds-sidebar-menu-item-text" translate>User Management</div>
      </a>
    }
    @if (
      authorizationService.hasPermission("SYSTEM_ADMIN,MANAGER,SECURITY_ADMIN")
    ) {
      <a
        [routerLink]="['/installation-management/user-permission']"
        class="cds-sidebar-menu-item"
        [ngClass]="{
          active: checkIfThisRouteIsActive(
            '/installation-management/user-permission'
          ),
        }"
      >
        <div class="cds-sidebar-menu-item-spacer"></div>
        <div class="cds-sidebar-menu-item-icon">
          <img
            class="mr-2"
            src="assets/img/icon-coloured-permission.svg"
            alt="User Permission"
          />
        </div>
        <div class="cds-sidebar-menu-item-text" translate>User Permission</div>
      </a>
    }
    @if (
      authorizationService.hasPermission(
        "USER,SYSTEM_ADMIN,MANAGER,SECURITY_ADMIN"
      )
    ) {
      <a
        [routerLink]="['/installation-management/log-tracer']"
        class="cds-sidebar-menu-item"
        [ngClass]="{
          active: checkIfThisRouteIsActive(
            '/installation-management/log-tracer'
          ),
        }"
      >
        <div class="cds-sidebar-menu-item-spacer"></div>
        <div class="cds-sidebar-menu-item-icon">
          <img
            class="mr-2"
            src="assets/img/icon-coloured-logtracer.svg"
            alt="Log Tracer"
          />
        </div>
        <div class="cds-sidebar-menu-item-text" translate>Log Tracer</div>
      </a>
    }
    @if (authorizationService.hasPermission("SYSTEM_ADMIN,SECURITY_ADMIN")) {
      <a
        [routerLink]="['/installation-management/python-management']"
        class="cds-sidebar-menu-item"
        [ngClass]="{
          active: checkIfThisRouteIsActive(
            '/installation-management/python-management'
          ),
        }"
      >
        <div class="cds-sidebar-menu-item-spacer"></div>
        <div class="cds-sidebar-menu-item-icon">
          <img
            class="mr-2"
            src="assets/img/icon-coloured-python.svg"
            alt="Python Management"
          />
        </div>
        <div class="cds-sidebar-menu-item-text" translate>
          Python Management
        </div>
      </a>
    }
  </div>
</div>
